import Vue from 'vue'
import Router from 'vue-router'
import AccueilComponent from '@/components/AccueilComponent'
import NewEnregistrementComponent from '@/components/NewEnregistrementComponent'
import DetailEchantillonComponent from '@/components/DetailEchantillonComponent'
import ResultatsComponent from '@/components/ResultatsComponent'

Vue.use(Router)

export default new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'accueil',
      component: AccueilComponent
    },
    {
      path: '/Resultats',
      name: 'resultats',
      component: ResultatsComponent
    },
    {
      path: '/Demande/Nouvelle',
      name: 'nouvelleDemande',
      component: NewEnregistrementComponent
    },
    {
      path: '/Demande/Echantillon/Detail',
      name: 'detailEchantillon',
      component: DetailEchantillonComponent
    },
    {
      path: '/Demande/Change',
      name: 'changeDemande'
      // component: testHome
    },
    {
      path: '/Demande/Recherche',
      name: 'rechercheDemande'
      // component: testHome
    },
    {
      path: '/Contact',
      name: 'contact'
      // component: testHome
    },
    {
      path: '/Utilisateur',
      name: 'comptaeUt'
      // component: testHome
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js